// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-gatsby-theme-ceteicean-components-ceteicean-tsx": () => import("./../../../src/gatsby-theme-ceteicean/components/Ceteicean.tsx" /* webpackChunkName: "component---src-gatsby-theme-ceteicean-components-ceteicean-tsx" */),
  "component---src-templates-introduction-tsx": () => import("./../../../src/templates/introduction.tsx" /* webpackChunkName: "component---src-templates-introduction-tsx" */)
}

